import { createSlice } from '@reduxjs/toolkit'

const initialState = { terminology: {}, fileValue: {}, itemData: {} }

const donationSlice = createSlice({
	name: 'donation',
	initialState,
	reducers: {
		setCurrentDonationItemData(state, { payload }) {
			return { ...state, itemData: { ...payload } }
		},
		setCurrentDonationTerminology(state, { payload }) {
			return { ...state, terminology: { ...payload } }
		},
		setCurrentDonationFileValue(state, { payload }) {
			return { ...state, fileValue: { ...payload } }
		},
	},
})

export const {
	setCurrentDonationItemData,
	setCurrentDonationTerminology,
	setCurrentDonationFileValue,
} = donationSlice.actions

export default donationSlice.reducer
